var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-benifits",
      attrs: { id: "app_benifits", name: "app_benifits" }
    },
    [
      _c("h3", { staticClass: "bf-title" }, [
        _vm._v(_vm._s(_vm.getConstants("EAGLE_LANDING_BENIFIT_TITLE")))
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "bf-subtitle" }, [
        _vm._v(
          "\n\t\t" +
            _vm._s(_vm.getConstants("EAGLE_LANDING_BENIFIT_SUBTITLE")) +
            "\n\t"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bf-detail" }, [
        _c("ul", { staticClass: "bf-detail-list dp-f" }, [
          _c("li", { staticClass: "block" }, [
            _c("div", { staticClass: "title icon-search" }, [
              _vm._v(
                "\n\t\t\t\t\t" +
                  _vm._s(
                    _vm.getConstants("EAGLE_LANDING_BENIFIT_BLOCK1_TITLE")
                  ) +
                  "\n\t\t\t\t"
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "compare" }, [
              _vm._v(
                "\n\t\t\t\t\t" +
                  _vm._s(
                    _vm.getConstants("EAGLE_LANDING_BENIFIT_BLOCK1_BEFORE")
                  ) +
                  "\n\t\t\t\t"
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "compare" }, [
              _vm._v(
                "\n\t\t\t\t\t" +
                  _vm._s(
                    _vm.getConstants("EAGLE_LANDING_BENIFIT_BLOCK1_AFTER")
                  ) +
                  "\n\t\t\t\t"
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "block" }, [
            _c("div", { staticClass: "title icon-sync" }, [
              _vm._v(
                "\n\t\t\t\t\t" +
                  _vm._s(
                    _vm.getConstants("EAGLE_LANDING_BENIFIT_BLOCK2_TITLE")
                  ) +
                  "\n\t\t\t\t"
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "compare" }, [
              _vm._v(
                "\n\t\t\t\t\t" +
                  _vm._s(
                    _vm.getConstants("EAGLE_LANDING_BENIFIT_BLOCK2_BEFORE")
                  ) +
                  "\n\t\t\t\t"
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "compare" }, [
              _vm._v(
                "\n\t\t\t\t\t" +
                  _vm._s(
                    _vm.getConstants("EAGLE_LANDING_BENIFIT_BLOCK2_AFTER")
                  ) +
                  "\n\t\t\t\t"
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "block" }, [
            _c("div", { staticClass: "title icon-delete" }, [
              _vm._v(
                "\n\t\t\t\t\t" +
                  _vm._s(
                    _vm.getConstants("EAGLE_LANDING_BENIFIT_BLOCK3_TITLE")
                  ) +
                  "\n\t\t\t\t"
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "compare" }, [
              _vm._v(
                "\n\t\t\t\t\t" +
                  _vm._s(
                    _vm.getConstants("EAGLE_LANDING_BENIFIT_BLOCK3_BEFORE")
                  ) +
                  "\n\t\t\t\t"
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "compare" }, [
              _vm._v(
                "\n\t\t\t\t\t" +
                  _vm._s(
                    _vm.getConstants("EAGLE_LANDING_BENIFIT_BLOCK3_AFTER")
                  ) +
                  "\n\t\t\t\t"
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "block" }, [
            _c("div", { staticClass: "title icon-easy" }, [
              _vm._v(
                "\n\t\t\t\t\t" +
                  _vm._s(
                    _vm.getConstants("EAGLE_LANDING_BENIFIT_BLOCK4_TITLE")
                  ) +
                  "\n\t\t\t\t"
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "compare" }, [
              _vm._v(
                "\n\t\t\t\t\t" +
                  _vm._s(
                    _vm.getConstants("EAGLE_LANDING_BENIFIT_BLOCK4_BEFORE")
                  ) +
                  "\n\t\t\t\t"
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "compare" }, [
              _vm._v(
                "\n\t\t\t\t\t" +
                  _vm._s(
                    _vm.getConstants("EAGLE_LANDING_BENIFIT_BLOCK4_AFTER")
                  ) +
                  "\n\t\t\t\t"
              )
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }